<template>
    <div style="display: flex; flex-direction: column;">
        <div style="position: relative;">
            <MercenaryHeader :title="'결제하기'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        </div>
        <div style="flex: 1; overflow-y: scroll; background-color: #F5F5F5;">
            <div style="padding:0 20px; margin: 16px 0">
                <div style="font-weight: 500; margin-bottom: 8px; line-height: 24px;">결제 정보</div>
                <div class="common_box" style="display: flex; font-weight: 400; font-size: 14px; color: #606060; justify-content: space-between;">
                    <div style="font-weight: 500; font-size: 14px; color: #808080;">결제 내용</div>
                    <div style="font-size: 14px; font-weight: 500; color: #210f03;">{{ goods_name }}</div>
                </div>
            </div>
            <div style="padding: 0 20px; margin-bottom: 16px;">
                <div style="font-weight: 500; margin-bottom: 8px; line-height: 24px;">결제 금액</div>
                <div class="common_box" style="font-weight: 500; font-size: 14px; justify-content: space-between;">
                    <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #ededed; padding-bottom: 12px;">
                        <div style="color: #808080;">{{ goods_name }}</div>
                        <div style="color: #210f03;">￦{{ amt | comma }}원</div>
                    </div>
                    <div style="display: flex; justify-content: space-between; padding-top: 12px; font-size: 16px;">
                        <div style="color: #808080;">합계 금액</div>
                        <div style="color: #210f03; ">￦{{ amt | comma }}원</div>
                    </div>
                </div>
            </div>
            <div style="padding: 0 20px; margin-bottom: 12px;">
                <div style="font-weight: 500; line-height: 24px;">결제 수단</div>
                <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #606060;">아래 결제 수단을 눌러 선택할 수 있습니다.</div>
            </div>
            <div style="padding: 0 20px; margin-bottom: 16px;">
                <div style="display: flex; justify-content: space-between;">
                    <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #808080; margin-bottom: 4px;">일반결제</div>
                    <div @click="showCardAdd(); $Util.sendEventClick('결제_결제수단_등록')" v-if="pay_methods.length === 0" style="font-size: 12px;font-weight: 500;line-height: 20px; color: var(--color-main);">결제수단 추가</div>
                </div>
                <!--<div v-for="each, i in pay_methods" class="each_card" :class="{active : pay_mode == INNOPAY_MODE.REGISTERED_CARD_PAY && selected_card_idx == each.idx }"-->
                <!--:key="i" @click="selectPayMethod(INNOPAY_MODE.REGISTERED_CARD_PAY, each.idx)">-->
                <!--{{each.card_number}}-->
                <!--</div>-->
                <template v-if="pay_methods.length === 0">
                    <div class="common_box" style="font-size: 14px;font-weight: 500;line-height: 24px; color: #808080; text-align: center">등록된 결제 수단이 없습니다.</div>
                </template>
                <template v-else>
                    <div :style="{ border: selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.CARD && selectedPayMethod.card_idx !== null ? '1px solid #808080' : '' }" class="common_box" style="padding: 0;">
                        <!-- @click="selectPayMethod(INNOPAY_PAY_METHOD.CARD, INNOPAY_MODE.REGISTERED_CARD_PAY, each.idx)" -->
                        <div @click="setPayMethods(INNOPAY_PAY_METHOD.CARD, INNOPAY_MODE.REGISTERED_CARD_PAY, each.idx, each)" v-for="each, i in pay_methods" :key="'a' + i" style="padding: 0; border-bottom: 1px solid #ededed;">
                            <CreditCard :needBoxShadow="false" :card_number="each.card_number" :bank_name="(each.card_code ? CARD_CODE_NAME[each.card_code] : '')" :expiry_date="each.mmyy" />
                        </div>
                        <div style="display: flex; justify-content: space-between; padding: 8px 20px;">
                            <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #606060;">다른 카드로 결제할까요?</div>
                            <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: var(--color-main);" @click="showPaymentRegist">결제수단 추가</div>
                        </div>
                    </div>
                </template>
                <!-- @click="selectPayMethod(INNOPAY_PAY_METHOD.CARD, INNOPAY_MODE.DIRECT_PAY, null); $Util.sendEventClick('결제_일반결제')" -->
                <div :style="{ border: selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.CARD && selectedPayMethod.pay_mode === INNOPAY_MODE.DIRECT_PAY && selectedPayMethod.card_idx === null ? '1px solid #808080' : '' }" @click="setPayMethods(INNOPAY_PAY_METHOD.CARD, INNOPAY_MODE.DIRECT_PAY, null)" style="margin-top:12px; display: flex; justify-content: space-between; align-items: center;" class="common_box">
                    <img style="width: 26px;" :src="require('@/assets/img/credit.png')" alt="">
                    <div style="font-size: 14px;font-weight: 500;">신용카드로 결제하기</div>
                </div>
            </div>
            <div style="padding: 0 20px;">
                <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #808080; margin-bottom: 4px;">간편결제</div>
                <div :style="{ border: selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.KAKAO && selectedPayMethod.pay_mode === INNOPAY_MODE.DIRECT_PAY && selectedPayMethod.card_idx === null ? '1px solid #808080' : '' }" @click="setPayMethods(INNOPAY_PAY_METHOD.KAKAO, INNOPAY_MODE.DIRECT_PAY, null)" style="display: flex; justify-content: space-between; align-items: center;" class="common_box">
                    <div>
                        <img :src="require('@/assets/img/icon_kakao_pay.png')" style="width: 44px;">
                        <img :src="require('@/assets/img/icon_naver_pay.png')" style="width: 48px; margin-left: 8px;">
                    </div>
                    <div style="font-size: 14px;font-weight: 500;">다양한 방법으로 간편결제</div>
                </div>
                <!-- <div class="each_card" style="display:flex; align-items: center;" @click="selectPayMethod(INNOPAY_PAY_METHOD.KAKAO, INNOPAY_MODE.DIRECT_PAY, null); $Util.sendEventClick('결제_간편결제')">간편 결제<img :src="require('@/assets/img/icon_kakao_pay.png')" style="height:16px; margin-left:10px;"><img :src="require('@/assets/img/icon_naver_pay.png')" style="height:16px; margin-left:10px;"></div> -->
            </div>
            <!--<div style="padding:10px 20px 10px 20px;">-->
            <!--<div></div>-->
            <!--<div class="each_card"  @click="selectPayMethod(INNOPAY_PAY_METHOD.NAVER, INNOPAY_MODE.DIRECT_PAY, null)">네이버 페이</div>-->
            <!--</div>-->
            <div v-if="isShowCancelNotice" style="padding:0px 20px;">
                <TeamTrainingCancelNotice />
            </div>
        </div>
        <div style="height: 93px; padding:0px 20px;">
            <div :style="{ backgroundColor: selectedPayMethod.pay_method === null ? '#ebebeb' : '#210f03' }" @click="selectPayMethod(selectedPayMethod.pay_method, selectedPayMethod.pay_mode, selectedPayMethod.card_idx)" class="common_btn">￦{{ amt | comma }}원 결제하기</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import {CARD_CODE_NAME, INNOPAY_MODE, WEB_PLATFORM_TYPE} from "../../Constants";
import CreditCard from "../common/CreditCard";
import { INNOPAY_PAY_METHOD } from "../../modules/InnoPay";
import TeamTrainingCancelNotice from "../mercenary/TeamTrainingCancelNotice";

export default {
    name: 'Payment',
    components: { TeamTrainingCancelNotice, CreditCard, MercenaryHeader },
    props: {
        payAction: {
            type: Function,
            default: () => { }
        },
        amt: {
            type: [Number, String],
            default: '',
        },
        goods_name: {
            type: [Number, String],
            default: '',
        },
        isShowCancelNotice: {
            type: Boolean,
            default: false
        },
        isParentPay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            CARD_CODE_NAME: CARD_CODE_NAME,
            INNOPAY_PAY_METHOD: INNOPAY_PAY_METHOD,
            INNOPAY_MODE: INNOPAY_MODE,
            pay_methods: [],
            selected_card_idx: '-1',
            pay_mode: '-1',
            pay_method: INNOPAY_PAY_METHOD.CARD,
            selectedPayMethod: {
                pay_method: null,
                pay_mode: null,
                card_idx: null,
                pay_info: null,
                amt: null,
                goods_name: null
            }
        }
    },
    methods: {
        showPaymentRegist() {
            this.$GlobalStore.addModal('PaymentRegist', { closeAction: () => { this.getMyRegisteredCards(); } });
        },
        setPayMethods(pay_method, pay_mode, card_idx, pay_info = null) {
            this.selectedPayMethod.pay_method = pay_method
            this.selectedPayMethod.pay_mode = pay_mode
            this.selectedPayMethod.card_idx = card_idx
            this.selectedPayMethod.goods_name = this.goods_name
            this.selectedPayMethod.amt = this.amt
            this.selectedPayMethod.pay_info = pay_info
        },
        showAlertImple() {
            this.$GlobalStore.showAlert('기능 구현 중입니다.');
        },
        async addPayEvent(){
            if(this.goods_name === '포지션 찾기 PRO'){
                const parameters = {};
                let type = '';
                if(this.selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.CARD){
                    if(this.selectedPayMethod.pay_mode === INNOPAY_MODE.DIRECT_PAY){
                        type = '포지션찾기PRO_신용카드_결제전';
                    }else {
                        type = '포지션찾기PRO_등록카드_결제전';
                    }
                }else if(this.selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.KAKAO || this.selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.NAVER){
                    type = '포지션찾기PRO_간편_결제전';
                }
                parameters.type = type;
                await this.$Axios.post('/api/log/event', parameters);
            }
        },
        selectPayMethod(pay_method, pay_mode, card_idx) {
            if (pay_method === null || pay_mode === null) {
                this.$GlobalStore.showAlert('결제 수단을 선택해주세요.')
                return
            }

            const device = this.$cookies.get('device');

            this.addPayEvent();

            if(!(device === 'android' || device === 'ios')){
                if(this.$Util.getWebPlatForm() === WEB_PLATFORM_TYPE.IOS && this.selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.KAKAO || this.selectedPayMethod.pay_method === INNOPAY_PAY_METHOD.NAVER){
                    this.$GlobalStore.showAlert('간편결제는 사파리(safari)나, 크롬 브라우저에서만 가능합니다\n오른쪽 상단에 ... 버튼에서 사파리에서 열기를 이용해주세요.');
                    return;
                }
            }

            // if(pay_method === INNOPAY_PAY_METHOD.KAKAO){
            //     this.$GlobalStore.showAlert('업데이트 예정입니다. \n일반 결제를 이용해주십시오')
            // }else {
            if (pay_mode === INNOPAY_MODE.REGISTERED_CARD_PAY) {
                this.$GlobalStore.showConfirm(`<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">결제하기</strong><br>등록하신 카드로<br>￦${this.$options.filters.comma(this.amt)}원을 즉시 결제할까요?`, () => {
                    this.pay_method = pay_method;
                    this.pay_mode = pay_mode;
                    this.selected_card_idx = card_idx;
                    this.pay();
                }, '결제하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
            } else {
                this.pay_method = pay_method;
                this.pay_mode = pay_mode;
                this.selected_card_idx = card_idx;
                this.pay();
            }
        },
        async getMyRegisteredCards() {
            const res = await this.$Axios.get('/api/paymethod/list');
            this.pay_methods = res.data.pay_methods;
        },
        pay() {
            if (this.pay_mode == '-1') {
                this.$GlobalStore.showAlert('결제방법을 선택해주세요.');
                return;
            }
            this.payAction(this.pay_method, this.pay_mode, this.selected_card_idx, this.selectedPayMethod);
        },
        showCardAdd() {
            this.$GlobalStore.addModal('CardAdd', { completeAction: this.getMyRegisteredCards });
        }
    },
    created() {
        this.getMyRegisteredCards();
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.common_btn {
    width: calc(100%);
    line-height: 50px;
    text-align: center;
    background-color: var(--color-main);
    border-radius: 12px;
    color: #fff;
    margin: 0 auto;
    margin-top: 20px;
}

.each_card {
    padding: 20px;
    font-size: 14px;
    box-shadow: 0px 1px 4px rgba(16, 16, 20, 0.15);
    border-radius: 12px;
    font-weight: 500;
}

.each_card.active {
    color: white;
    background-color: var(--color-main);
}

.common_box {
    padding: 13px 16px;
    background-color: #fff;
    border-radius: 12px;
}
</style>